import { layoutZIndex } from '~/theme';

export const useSxStyles = () => {
  return {
    viewContainer: {
      height: '100%',
      position: 'relative',
      display: 'grid',
      gridTemplateRows: '50px 1fr 50px',
      gridTemplateColumns: '100%',
      gridTemplateAreas: `
          "header"
          "content"
          "footer"
        `,
    },
    viewHeader: {
      gridArea: 'header',
    },
    pageContainer: {
      gridArea: 'content',
      overflow: 'auto',
    },
    viewFooter: {
      gridArea: 'footer',
      zIndex: layoutZIndex.portal.footer,
    },
    loading: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
    },
  };
};
